export const SITE_URL = "https://romarottamazioni.com";

export const ZONES = [
  {
    slug: "roma-centro",
    name: "Roma Centro",
    tag: "Municipio I",
    micro: ["Centro Storico", "Prati", "Trastevere", "Testaccio", "Esquilino", "Monti", "Trieste", "Salario"],
    intro: "Rottamazione auto a Roma Centro con ritiro gratuito a domicilio. Operiamo in tutto il Municipio I, dalle strette vie del Centro Storico fino a Prati e Trastevere, gestendo il carroattrezzi anche nelle zone a traffico limitato (ZTL).",
    body: "Vivere in centro significa spesso avere un'auto vecchia o fuori uso che occupa un posto prezioso. Ci pensiamo noi: ritiriamo il veicolo direttamente sotto casa, senza costi, e gestiamo la radiazione al PRA e il certificato di demolizione. Interveniamo anche su auto senza revisione, incidentate o ferme da anni in garage e box.",
  },
  {
    slug: "eur",
    name: "EUR",
    tag: "Municipio IX",
    micro: ["EUR", "Torrino", "Laurentino", "Cecchignola", "Mostacciano", "Fonte Meravigliosa", "Vigna Murata", "Spinaceto"],
    intro: "Rottamazione auto all'EUR e nel Municipio IX con ritiro gratuito. Serviamo tutta la zona sud di Roma, dai palazzi dell'EUR fino a Torrino, Laurentino e Spinaceto.",
    body: "Che tu debba rottamare un'utilitaria, un SUV o un furgone commerciale, organizziamo il ritiro in giornata o all'orario che preferisci. Nessuna fila agli uffici: curiamo noi tutta la burocrazia e ti consegniamo il certificato di avvenuta demolizione a norma di legge.",
  },
  {
    slug: "prati",
    name: "Prati",
    tag: "Municipio I",
    micro: ["Prati", "Delle Vittorie", "Cola di Rienzo", "Lepanto", "Ottaviano", "Mazzini", "Trionfale", "Balduina"],
    intro: "Rottamazione auto a Prati con ritiro gratuito a domicilio. Copriamo tutto il quartiere, da Cola di Rienzo a Lepanto e la zona Trionfale, con carroattrezzi disponibile anche in strade con parcheggio difficile.",
    body: "A Prati lo spazio è oro: liberati dell'auto che non usi più senza stress. Ritiriamo veicoli di ogni marca, funzionanti o meno, con o senza documenti completi, e gestiamo la radiazione al Pubblico Registro Automobilistico. Servizio attivo h24, 7 giorni su 7.",
  },
  {
    slug: "trastevere",
    name: "Trastevere",
    tag: "Municipio I",
    micro: ["Trastevere", "Gianicolense", "Monteverde", "Portuense", "Marconi", "San Cosimato", "Colli Portuensi"],
    intro: "Rottamazione auto a Trastevere e Monteverde con ritiro gratuito. Interveniamo nelle vie strette del quartiere e nella zona Gianicolense-Portuense con mezzi adatti ad ogni situazione.",
    body: "Auto vecchia, moto ferma o furgone incidentato? Organizziamo il ritiro all'indirizzo che indichi, senza alcun costo, e trasformiamo un problema in una pratica chiusa. Ti consegniamo il certificato di demolizione e curiamo noi la radiazione.",
  },
  {
    slug: "tuscolano",
    name: "Tuscolano",
    tag: "Municipio VII",
    micro: ["Tuscolano", "Cinecittà", "Don Bosco", "Quadraro", "Appio Claudio", "Furio Camillo", "Numidio Quadrato"],
    intro: "Rottamazione auto in zona Tuscolano-Cinecittà con ritiro gratuito a domicilio. Serviamo tutto il Municipio VII, da Don Bosco al Quadraro fino ad Appio Claudio.",
    body: "Ritiriamo autovetture, moto e veicoli commerciali direttamente a casa tua. Anche mezzi senza revisione o fermi da tempo: pensiamo noi al trasporto con carroattrezzi e a tutte le pratiche di demolizione e radiazione al PRA, senza costi per te.",
  },
  {
    slug: "appio-latino",
    name: "Appio Latino",
    tag: "Municipio VII / VIII",
    micro: ["Appio Latino", "San Giovanni", "Re di Roma", "Colli Albani", "Furio Camillo", "Ardeatino", "Garbatella"],
    intro: "Rottamazione auto in zona Appio Latino e San Giovanni con ritiro gratuito. Copriamo l'area tra Re di Roma, Colli Albani e la Garbatella.",
    body: "Serve rottamare un'auto o uno scooter? Fissiamo l'appuntamento e ritiriamo il veicolo dove preferisci. Ci occupiamo di ogni adempimento burocratico e ti rilasciamo il certificato di demolizione ufficiale. Servizio rapido, gratuito e attivo tutti i giorni.",
  },
  {
    slug: "nomentano-montesacro",
    name: "Nomentano · Montesacro",
    tag: "Municipio II / III",
    micro: ["Nomentano", "Montesacro", "Talenti", "Fidene", "Bufalotta", "Conca d'Oro", "Città Giardino", "Sacco Pastore"],
    intro: "Rottamazione auto in zona Nomentano e Montesacro con ritiro gratuito a domicilio. Serviamo tutta l'area nord-est di Roma, da Talenti a Fidene e Conca d'Oro.",
    body: "Ritiro gratuito di auto, moto e furgoni in tutto il quadrante nord. Anche veicoli incidentati o senza documenti completi: valutiamo ogni situazione e gestiamo radiazione al PRA e certificato di demolizione. Nessuna coda, nessun pensiero.",
  },
  {
    slug: "aurelio",
    name: "Aurelio",
    tag: "Municipio XIII",
    micro: ["Aurelio", "Boccea", "Casalotti", "Primavalle", "Torrevecchia", "Val Cannuta", "Battistini", "Cornelia"],
    intro: "Rottamazione auto in zona Aurelio-Boccea con ritiro gratuito. Copriamo tutto il Municipio XIII, da Battistini a Casalotti e Primavalle.",
    body: "Liberati del veicolo che non usi più: ritiro a domicilio gratuito, demolizione in centro autorizzato e pratiche complete. Interveniamo con carroattrezzi su auto ferme, incidentate o non più a norma, in tutta la zona ovest di Roma.",
  },
  {
    slug: "ostia-litorale",
    name: "Ostia · Litorale",
    tag: "Municipio X",
    micro: ["Ostia", "Ostia Antica", "Acilia", "Casal Palocco", "Infernetto", "Axa", "Dragona", "Fiumicino"],
    intro: "Rottamazione auto a Ostia e sul litorale romano con ritiro gratuito. Serviamo tutto il Municipio X, da Ostia Lido ad Acilia, Casal Palocco e fino a Fiumicino.",
    body: "Sul litorale la salsedine mette a dura prova le auto: quando è il momento di rottamare, ci pensiamo noi. Ritiro gratuito a domicilio, trasporto con carroattrezzi e disbrigo di tutte le pratiche di radiazione e demolizione. Servizio attivo h24.",
  },
  {
    slug: "casilino-prenestino",
    name: "Casilino · Prenestino",
    tag: "Municipio V / VI",
    micro: ["Casilino", "Prenestino", "Centocelle", "Torpignattara", "Pigneto", "Tor Bella Monaca", "Torre Angela", "Alessandrino"],
    intro: "Rottamazione auto in zona Casilino e Prenestino con ritiro gratuito a domicilio. Copriamo tutta l'area est di Roma, da Centocelle a Torpignattara e Tor Bella Monaca.",
    body: "Ritiriamo gratuitamente auto, moto e veicoli commerciali in tutto il quadrante est. Gestiamo la demolizione in impianti autorizzati e la radiazione al PRA, consegnandoti il certificato ufficiale. Interveniamo anche su mezzi fermi da anni o incidentati.",
  },
];

export const getZone = (slug) => ZONES.find((z) => z.slug === slug);
